// extracted by mini-css-extract-plugin
module.exports = {"expanded":"settings-title_expanded__H7c_2","nav":"settings-title_nav__goV_f","desc":"settings-title_desc___9tNa","help":"settings-title_help__3YYhn"};